module.exports = "<div class=\"js-dropdown-region dropdown-bubble\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/membersBubbleEditor.hbs
// module id = 688
// module chunks = 0